import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { TranslateLoader } from '@ngx-translate/core';
import { all } from 'deepmerge';
import { BehaviorSubject, forkJoin, Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { ITranslationResource } from './i18n.module';

// tslint:disable-next-line: no-any
const cache: Record<string, any> = {};

export class CacheTranslateHttpLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly resources: ITranslationResource[]
  ) {}

  private readonly _labelsLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly labelsLoaded$: Observable<boolean> = this._labelsLoaded$.asObservable().pipe(distinctUntilChanged());

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<Record<string, any>> {
    const requests = this.resources.map(resource => {
      const path = resource.prefix + lang + resource.suffix;
      if (cache[path]) {
        return of({});
      }
      return this.http.get(`${path}?t=${Date.now()}`).pipe(
        tap(response => {
          cache[path] = response;
          this._labelsLoaded$.next(true);
        }),
        catchError(res => {
          if (!environment.production) {
            console.error('Something went wrong for the following translation file:', path);
            console.error(res.message);
          }
          return of({});
        })
      );
    });
    return forkJoin(requests).pipe(map(response => all(response)));
  }
}
